
import { ref } from 'vue';
import { defineStore } from 'pinia';
import ApiService from '@/common/api.service';
import { saveOrganization, saveOrganizations } from '@/common/organization.service';

export const useOrganizationStore = defineStore('organization', () => {
  // State
  const organizations = ref([]);
  const organization = ref({});
  const organizationId = ref(null);
  const organizationEula = ref(null);
  const organizationEulaTitle = ref(null);

  // Getters
  // No direct getters, computed properties can be used if needed

  // Actions
  function setOrganizations(orgs) {
    organizations.value = orgs;
    saveOrganizations(orgs);
  }

  function setOrganization(org) {
    organization.value = org;
    organizationId.value = org.id;
  }

  function setOrganizationId(id) {
    const intId = parseInt(id, 10);
    organizationId.value = intId;
    const filteredOrganization = organizations.value.filter((org) => org.id === intId);
    if (filteredOrganization.length > 0) {
      [organization.value] = filteredOrganization;
      saveOrganization(organization.value);
    }
  }

  function setOrganizationEula(data) {
    organizationEula.value = data.content;
    organizationEulaTitle.value = `${data.type}.modal.title`;
  }

  async function fetchOrganizations() {
    const { data: response } = await ApiService.get('front/v1/organizations');
    const { data } = response;
    setOrganizations(data.organizations);
    return response;
  }

  async function checkOrganizationAccess() {
    if (!organizationId.value) return Promise.reject('No organization ID set');
    return ApiService.get(`front/v1/organization/${organizationId.value}/check_access`);
  }

  async function checkOrganizationDomain(params = {}) {
    const { data: response } = await ApiService.query('public/check_domain', params);
    const { data } = response;
    setOrganizations(data.organizations);
    setOrganization(data.organizations[0]);
    // setOrganizationId is called within setOrganization
    return response;
  }

  async function fetchOrganizationEula(type) {
     if (!organizationId.value) return Promise.reject('No organization ID set');
    const { data: response } = await ApiService.get(`public/organization/${organizationId.value}/${type}`);
    const { data } = response;
    setOrganizationEula({ content: data.content, type });
    return response;
  }

  return {
    organizations,
    organization,
    organizationId,
    organizationEula,
    organizationEulaTitle,
    setOrganizations,
    setOrganization,
    setOrganizationId,
    fetchOrganizations,
    checkOrganizationAccess,
    checkOrganizationDomain,
    fetchOrganizationEula,
  };
});
